<template>
  <div class="team-card-container md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-100 md-xsmall-size-100">
    <div class="card-image">
      <slot name="card-image" />
    </div>
    <div class="card-contents">
      <slot name="card-details" />
    </div>
  </div>
</template>
<script>
export default {
  name: "StudioList"
}
</script>
<style lang="scss">
.team-card-container {
  min-height: 230px;;
  overflow: hidden;
  background-color: $color-white;
  object-fit: contain;
  border-radius: 7px;
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  &:not(:last-child) {
    margin-right: 15px;
  }
  .card-image {
    min-height: 91px;
    max-height: 91px;
    margin-bottom: -20px;
    .image-avatar {
      position: relative;
      display: block;
      margin: auto
    }
    .boder-image-circle {
      height: inherit;
      min-height: inherit;
      max-height: inherit;
      img {
        width: 91px;
        height:91px;
        display: block;
        margin: auto;
        border-radius: 50%;
        border: 2px solid $color-primary;
        margin-top: 18px;
      }
    }
  }
  .card-contents {
    margin: 24px;
    text-align: left;
    h1 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: $color-black;
    }
  }
}
</style>